import { InputFieldStyles } from "@smartsuite/react-ui/lib/components/forms/InputField/InputField.constants";

export const inputStylesWhiteNew: InputFieldStyles = {
  height: 32,
  placeholderColor: "secondary",
};
